import type { Permission } from './types'

export const appShellPermissions = {
  // superAdmin is a cross-tenant access marker, not a grant-all: on logout the user's
  // tenantId is cleared instead of being pinned to one tenant, and they may join any
  // tenant instead of being bound to one via a join code. No PermissionValidator check
  // bypasses it.
  superAdmin: {
    value: 'superAdmin',
    label: 'Super Admin',
    description: 'Marks the user as not tied to a single tenant — they may join or switch between any tenant, and their tenant is cleared on logout. This is not a grant-all: every other permission is still checked individually.',
  } satisfies Permission,

  admin: {
    canAccess: {
      value: 'admin',
      label: 'Can Access',
      description: 'The admin of the instance of the application.',
    } satisfies Permission,
  },

  overview: {
    canView: {
      value: 'overview.canView',
      label: 'Can View',
      description: 'The user can view the dashboard page',
    } satisfies Permission,
  },

  reports: {
    canView: {
      value: 'reports.canView',
      label: 'Can View',
      description: 'The user can view the list of reports.',
    } satisfies Permission,
  },

  setting: {
    canView: {
      value: 'setting.canView',
      label: 'Can View',
      description: 'No modification can be done to the settings, only viewing of details.',
    } satisfies Permission,
    canEdit: {
      value: 'setting.canEdit',
      label: 'Can Edit',
      description: 'Can modify the records for all fields of settings',
    } satisfies Permission,
  },
}
